module.exports = __webpack_public_path__ + "media/images/pic/future_sight_orange-8b0cf5eb695d69f59f263c0746d4fa1a.svg";